import React from "react";
import "../../styles/css/Contacts.css";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
}

const ItemList = (props) => {
  const handleClick = (props) => {
    props.setMapData(props.data.contactos);
  };

  return (
    <ListItem
      button
      onClick={() => handleClick(props)}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "baseline",
        margin: "5px",
      }}
    >
      {" "}
      <div>
        Nombre: {props.data.usuario.nombre} {props.data.usuario.apellido}
      </div>
      <div>Tiempo de contacto: {msToTime(props.data.tiempoContacto)}</div>
    </ListItem>
  );
};

const ContactList = (props) => {
  return (
    <Paper style={{ margin: "20px", width: "40%" }}>
      <Typography variant="h6">Contactos</Typography>
      <List style={{ display: "flex", flexDirection: "column" }}>
        {props.data.length == 0 ? (
          <div style={{ marginTop: "150px" }}> No existen contactos</div>
        ) : (
          <div>
            {props.data.map((contact) => {
              return <ItemList data={contact} setMapData={props.setMapData} />;
            })}
          </div>
        )}
      </List>
    </Paper>
  );
};

export default ContactList;
